import { RoleKeys, UserRoleKey } from './types'

export const ROLE_KEY_LABELS: Record<RoleKeys, UserRoleKey> = {
    [RoleKeys.SUPER_ADMIN]: UserRoleKey.SUPER_ADMIN,
    [RoleKeys.ORGANIZATION_ADMIN]: UserRoleKey.ORGANIZATION_ADMIN,
    [RoleKeys.UNIT_ADMIN]: UserRoleKey.UNIT_ADMIN,
    [RoleKeys.TECHNICAL_DELEGATE]: UserRoleKey.TECHNICAL_DELEGATE,
    [RoleKeys.TECHNICIAN]: UserRoleKey.TECHNICIAN,
    [RoleKeys.NOTETAKER]: UserRoleKey.NOTETAKER,
    [RoleKeys.TEAM_ADMIN]: UserRoleKey.TEAM_ADMIN,
    [RoleKeys.RECREATION_ADMIN]: UserRoleKey.RECREATION_ADMIN,
    [RoleKeys.RECREATION_TRAINER]: UserRoleKey.RECREATION_TRAINER,
    [RoleKeys.CMS_ADMIN]: UserRoleKey.CMS_ADMIN,
    [RoleKeys.CMS_EDITOR]: UserRoleKey.CMS_EDITOR,
    [RoleKeys.ADMIN]: UserRoleKey.ADMIN,
} as const

export const CMS_ROLE_KEYS = [RoleKeys.CMS_ADMIN, RoleKeys.CMS_EDITOR] as const

export const ADMIN_ROLE_KEYS = [
    RoleKeys.SUPER_ADMIN,
    RoleKeys.ORGANIZATION_ADMIN,
    RoleKeys.UNIT_ADMIN,
] as const
